var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { put, call, takeLatest } from 'redux-saga/effects';
import 'whatwg-fetch';
import { loadGiftcardBalanceComplete, } from './../giftcard/actions';
var loadBalancePromise = function (action) {
    var giftcardApiUrl = process.env.REACT_APP_GIFT_CARD_QR_URL;
    if (!giftcardApiUrl || giftcardApiUrl.length === 0) {
        return {
            giftcardNumber: action.giftcardNumber,
            error: 'giftcard.error.config',
        };
    }
    var url = giftcardApiUrl;
    var query = {
        clientId: 197,
        transactionUuid: '55f404c05b6e4c518b0bbf9008d5d645',
        operatorId: '999',
    };
    if (action.giftcardNumber.length === 16)
        query.cashCardCode1d = action.giftcardNumber;
    else
        query.cashCardCode2d = action.giftcardNumber;
    return new Promise(function (resolve, reject) {
        fetch(url + JSON.stringify(query))
            .then(function (response) {
            response.json().then(function (jsonObj) {
                if (!jsonObj || jsonObj.errorInfo)
                    resolve({
                        giftcardNumber: action.giftcardNumber,
                        error: 'giftcard.error.notfound',
                    });
                else
                    resolve({
                        giftcardNumber: action.giftcardNumber,
                        balance: jsonObj.cashCardBalance,
                    });
            });
        })
            .catch(function (response) {
            resolve({
                giftcardNumber: action.giftcardNumber,
                error: 'giftcard.error.server',
            });
        });
    });
};
export function startLoadGiftcardBalance(action) {
    var balanceResult;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, call([undefined, loadBalancePromise], action)];
            case 1:
                balanceResult = _a.sent();
                return [4 /*yield*/, put(loadGiftcardBalanceComplete(balanceResult))];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
export function endLoadGiftcardBalance() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeLatest('LOAD_GIFTCARD_BALANCE', startLoadGiftcardBalance)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
